<template>
    <div class="bg-white from-gray-50 to-gray-100 min-h-screen py-8">
        <div class="w-[90%] mx-auto px-4 sm:px-6 lg:px-8">

            <!-- Card principale -->
            <div class="bg-white rounded-2xl shadow border border-gray-200/50 overflow-hidden backdrop-blur-sm mb-3">
                <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 p-8 lg:p-12">

                    <!-- Section gauche : Couverture + Boutons -->
                    <div class="lg:col-span-3 space-y-4">
                        <BookCover v-if="book.banners"
                                   :cover-image="book.banners"
                                   cover-image-size="cover"
                                   :cover-overlay="false"
                                   :left-side-title="book.title"
                                   :left-side-author="book.author"
                                   left-side-color="#333"
                                   back-color="#444"/>

                        <div class="space-y-4">
                            <button
                                v-if="book.book_type !== 'Travaux' && book.isLoanable"
                                @click="book.isAvailable ? loanBook(book.id) : reserveBook(book.id)"
                                class="w-full py-3 px-6 rounded-sm font-semibold transition-all duration-300 hover:scale-105 border border-gray-200 disabled:bg-gray-100 disabled:text-gray-500"
                                :disabled="bookState"
                            >
                                <i class="fi fi-rr-refresh mr-2"></i>
                                {{ book.isAvailable ? 'Emprunter' : 'Réserver' }}
                            </button>

                            <div :class="book.book_type !== 'Travaux' ? 'flex gap-4 flex-wrap' : 'flex flex-col gap-4'">
                                <!-- Favoris -->
                                <button
                                    @click="isFavorite ? removeFavoris(book.id) : addFavoris(book.id)"
                                    :class="[
                                        'py-3 px-6 rounded-sm font-medium transition-all duration-300 text-center',
                                        book.book_type !== 'Travaux' ? 'flex-1' : 'w-full',
                                        isFavorite
                                          ? 'bg-gradient-to-r from-red-50 to-red-100 text-red-600 border-2 border-red-200 hover:from-red-100 hover:to-red-200'
                                          : 'bg-white text-gray-700 border-2 border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                                    ]"
                                >
                                    <i class="fi fi-rr-heart mr-1"></i>
                                    {{ favoriteButtonText }}
                                </button>

                                <!-- Partager -->
                                <button
                                    @click="copyLink"
                                    :class="[
                                        'py-3 px-6 rounded-sm font-medium bg-[#2A3992] text-white text-center hover:scale-105 transition-all duration-300',
                                        book.book_type !== 'Travaux' ? 'flex-1' : 'w-full'
                                    ]"
                                >
                                    <i class="fi fi-rr-share mr-1"></i>
                                    Partager
                                </button>
                            </div>
                        </div>
                    </div>

                    <!--Détails du livre -->
                    <div class="lg:col-span-5 space-y-6">

                        <!-- Titre et auteur -->
                        <div class="space-y-2">
                            <h1 class="text-3xl font-bold text-gray-900 leading-tight">
                                {{ book.title ?? '' }}
                            </h1>
                            <p class="inline-flex items-center px-3 py-1 rounded text-xs font-medium bg-gradient-to-r from-blue-50 to-blue-100 text-blue-800 border border-blue-200 hover:from-blue-100 hover:to-blue-200 cursor-pointer">
                                {{ book.book_type }}
                            </p>
                            <p v-if="book.subtitle" class="text-lg text-gray-600 leading-relaxed">
                                {{ book.subtitle }}
                            </p>
                            <p class="text-lg text-gray-700 flex flex-1">
                                par <span class="font-semibold text-gray-900"> {{
                                    book.authors?.split(',', 1)[0]
                                }}</span>
                                <span v-if="book.evaluation>0" class="ms-3 flex flex-1">
                                    <span
                                        v-for="star in 5"
                                        :key="star"
                                        :class="[
                                              'transition-colors duration-300 ',
                                              star <= book.evaluation ? 'text-yellow-400 ' : 'text-gray-200'
                                            ]"
                                    >
                                    <svg class="w-4 h-4 sm:w-5 sm:h-5 fill-current bg-opacity-0" viewBox="0 0 20 20">
                                        <path
                                            d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
                                    </svg>
                                </span>
                                </span>


                            </p>
                        </div>

                        <!-- Détails de publication -->
                        <div class="bg-white rounded-xl border border-gray-200 p-6">
                            <h3 class="text-lg font-semibold text-gray-900 mb-4">Informations</h3>
                            <div v-if="book.book_type === 'Monographie'">
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div class="space-y-4">
                                        <!--                                        <div class="flex justify-between items-center py-2 border-b border-gray-100">-->
                                        <!--                                            <span class="font-medium text-gray-500">ISBN</span>-->
                                        <!--                                            <span class="text-gray-900 font-mono text-sm">{{-->
                                        <!--                                                    book.isbn ?? 'Indisponible'-->
                                        <!--                                                }}</span>-->
                                        <!--                                        </div>-->
                                        <div class="flex justify-between items-center py-2 border-b border-gray-100">
                                            <span class="font-medium text-gray-500">Cote</span>
                                            <span class="text-gray-900">{{
                                                    book.cote?.trim() != '' ? book.cote : 'Indisponible'
                                                }}</span>
                                        </div>
                                        <div class="flex justify-between items-center py-2 border-b border-gray-100">
                                            <span class="font-medium text-gray-500">Éditeur</span>
                                            <span class="text-gray-900">{{
                                                    book.editeur ? book.editeur.length > 10 ? subChar(book.editeur, 10) : book.editeur : 'Indisponible'
                                                }}</span>
                                        </div>
                                        <div class="flex justify-between items-center py-2 border-b border-gray-100">
                                            <span class="font-medium text-gray-500">Pages</span>
                                            <span class="text-gray-900">{{
                                                    book.pages ? book.pages + ' pages' : 'Indisponible'
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="space-y-4">
                                        <div class="flex justify-between items-center py-2 border-b border-gray-100">
                                            <span class="font-medium text-gray-500">Parution</span>
                                            <span class="text-gray-900">{{
                                                    formatDate(book?.publication_date) ?? 'Indisponible'
                                                }}</span>
                                        </div>

                                        <div class="flex justify-between items-center py-2 border-b border-gray-100">
                                            <span class="font-medium text-gray-500">Collection</span>
                                            <span class="text-gray-900">{{
                                                    (book?.collection?.trim() != '') ? book.collection : 'Indisponible'
                                                }}</span>
                                        </div>
                                        <div class="flex justify-between items-center py-2 border-b border-gray-100">
                                            <span class="font-medium text-gray-500">Édition</span>
                                            <span class="text-gray-900">{{
                                                    (book?.edition?.trim() != '') ? book.edition : 'Indisponible'
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <detail-travaux :book="book"/>
                            </div>

                        </div>
                        <div
                            class="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6 flex flex-col h-50 border border-gray-200/50">

                            <!-- En-tête -->
                            <div class="mb-6">
                                <h3 class="text-xl font-bold text-gray-900 flex items-center gap-2">
                                    <i class="fi fi-rr-book-open text-blue-600"></i>
                                    Extrait
                                </h3>
                            </div>

                            <!-- Contenu -->
                            <div class="flex-1 mb-6">
                                <div class="prose prose-sm max-w-none">
                                    <p
                                        class="text-gray-700 leading-relaxed text-justify mb-4 text-sm"
                                        :class="{'line-clamp-2': !showFullExtrait}"
                                    >
                                        {{ book.extrait?.trim() !== '' ? book.extrait : 'Extrait non disponible' }}
                                    </p>
                                    <button
                                        v-if="book.extrait?.length > 0"
                                        @click="showFullExtrait = !showFullExtrait"
                                        class="mt-1 text-blue-600 text-xs font-medium hover:underline"
                                    >
                                        {{ showFullExtrait ? 'Voir moins' : 'Voir plus' }}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>


                    <!--                    coté droit-->
                    <div class="lg:col-span-4 w-full h-fit bg-white overflow-hidden ">

                        <!-- Contenu principal -->
                        <div
                            class="py-8 px-7 bg-gradient-to-br from-green-50 via-white to-blue-50 rounded-2xl border-2 transition-shadow duration-300"
                            style="border-color: #2A3992;">

                            <!-- Badge bibliothèque -->
                            <div class="flex items-center justify-between mb-6">
                                <div class="flex items-center gap-3">
                                    <div class="p-2 rounded-lg shadow-md"
                                         style="background:  #2A3992;">
                                        <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor"
                                             viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                                        </svg>
                                    </div>
                                    <span
                                        class="text-sm font-bold text-slate-700 uppercase tracking-wider">Bibliothèque</span>
                                </div>
                                <span style="background: rgba(42,57,147,0.15);color: #2A3993;padding: 8px;border-radius: 5px;font-weight: bold">{{ book.cote?.trim() != '' ? book.cote : 'Indisponible'  }}</span>

                            </div>

                            <!-- Titre et sous-titre -->
                            <div class="mb-4">
                                <h1 class="lg:text-lg text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-slate-800 to-slate-600 mb-3 leading-tight">
                                    {{ book.title }}
                                </h1>
                                <p class="lg:text-sm text-lg text-slate-500 italic font-medium">
                                    {{ book.subtitle ?? 'Pas de sous titre' }}
                                </p>
                            </div>

                            <!-- Séparateur -->
                            <div class="h-1 rounded-full mb-6 shadow-sm"
                                 style="background:  #2A3992;"></div>

                            <!-- Informations détaillées -->
                            <div class="grid grid-cols-2 gap-8 mb-6">

                                <div class="space-y-4">
                                    <div class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color: #2A3992;"></span>
                                            Auteur
                                        </dt>
                                        <dd class="text-sm font-semibold text-slate-800 pl-3.5">{{
                                                book.authors?.split(',', 1)[0]
                                            }}
                                        </dd>
                                    </div>

                                    <div class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color: #2A3992;"></span>
                                            ISBN
                                        </dt>
                                        <dd class="text-sm font-mono font-semibold text-slate-700 pl-3.5 bg-slate-50 px-3 py-1.5 rounded-lg inline-block">
                                            {{ book.isbn }}
                                        </dd>
                                    </div>

                                    <div class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color: #2A3992;"></span>
                                            Éditeur
                                        </dt>
                                        <dd class="text-sm font-medium text-slate-700 pl-3.5">
                                            {{ book.editeur ?? 'Indisponible' }}
                                        </dd>
                                    </div>
                                    <div v-if="book.book_type!=='Monographie'" class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color:#2A3992;"></span>
                                            Source
                                        </dt>
                                        <dd class="text-sm font-medium text-slate-700 pl-3.5">
                                            {{ book.source?.trim()!='' ?book.source :'Indisponible' }}
                                        </dd>
                                    </div>
                                    <div class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color: #2A3992;"></span>
                                            Collection
                                        </dt>
                                        <dd class="text-sm font-medium text-slate-700 pl-3.5">
                                            {{ book?.collection !== '' ? book?.collection : 'Indisponible' }}
                                        </dd>
                                    </div>

                                </div>

                                <div class="space-y-4">
                                    <div class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color: #2A3992;"></span>
                                            Cote
                                        </dt>
                                        <dd class="text-sm font-black pl-3.5 px-3 py-1.5 rounded-lg inline-block"
                                            style="color: #2A3992; background-color: rgba(42, 57, 146, 0.1);">{{
                                                book.cote?.trim() != '' ? book.cote : 'Indisponible'
                                            }}
                                        </dd>
                                    </div>

                                    <div class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color: #2A3992;"></span>
                                            Année
                                        </dt>
                                        <dd class="text-sm font-semibold text-slate-700 pl-3.5">{{
                                                book.publication_date?.trim()!=''?book.publication_date:'Indisponible'
                                            }}
                                        </dd>
                                    </div>

                                    <div class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color: #2A3992;"></span>
                                            Pages
                                        </dt>
                                        <dd class="text-sm font-semibold text-slate-700 pl-3.5">
                                            {{ book.pages ? book.pages + ' pages' : 'Indisponible' }}
                                        </dd>
                                    </div>
                                    <div v-if="book.promotion" class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color: #2A3992;"></span>
                                            Promotion
                                        </dt>
                                        <dd class="text-sm font-semibold text-slate-700 pl-3.5">
                                            {{ book.promotion ?? 'Indisponible' }}
                                        </dd>
                                    </div>
                                    <div v-if="book.book_type=='Monographie' && book.preface" class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color: #2A3992;"></span>
                                            Préfacé
                                        </dt>
                                        <dd class="text-sm font-medium text-slate-700 pl-3.5">
                                            {{ book.preface ?? 'Indisponible' }}
                                        </dd>
                                    </div>
                                    <div v-if="book.book_type!=='Monographie'" class="group">
                                        <dt class="text-xs font-bold uppercase tracking-wider mb-2 flex items-center gap-2"
                                            style="color: #2A3992;">
                                            <span class="w-1.5 h-1.5 rounded-full"
                                                  style="background-color: #2A3992;"></span>
                                            Note
                                        </dt>
                                        <dd class="text-sm font-medium text-slate-700 pl-3.5">
                                            {{ book.note ?? 'Indisponible' }}
                                        </dd>
                                    </div>
                                    <!-- Catégories -->
                                    <div class="mb-2">
                                        <dt class="text-xs font-bold text-slate-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                            <span class="w-1.5 h-1.5 bg-slate-500 rounded-full"></span>
                                            Mots clés
                                        </dt>
                                        <div class="flex flex-wrap gap-2">
                                    <span v-for="keyword in book.mots_cles"
                                          v-if="keyword?.trim() !== ''"
                                          :key="keyword"
                                          class="px-4 py-2 text-white rounded-full text-sm font-semibold shadow-md hover:shadow-lg hover:scale-105 transition-all duration-200"
                                          style="background: linear-gradient(to right, #2A3992, #1e2a6b);">
                                        {{ keyword }}
                                    </span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <!-- Boutons d'action -->
                        <div class="space-y-3 mt-1">

                            <button
                                v-if="book.isNumerique && book.book_file"
                                @click="openBookReader"
                                class="block w-full text-center text-blue-600 font-semibold py-3 px-4 bg-white border-2 border-blue-200 hover:bg-blue-50 hover:border-blue-300 rounded-sm transition-all duration-300 hover:scale-105"
                            >
                                <i class="fi fi-rr-eye mr-2"></i>
                                Lire l'ouvrage
                            </button>

                            <div
                                v-else-if="book.id"
                                class="block w-full text-center text-gray-500 font-medium py-3 px-4 bg-gray-100 border border-gray-200 rounded-sm"
                            >
                                <i class="fi fi-rr-book mr-2"></i>
                                Livre physique uniquement
                            </div>

                            <!-- Bouton Consulter -->
                            <form
                                @submit.prevent
                                :action="props.consultationRoute"
                                method="POST"
                                class="btn btn-warning mr-2"
                            >
                                <input type="hidden" name="_token" :value="props.csrf_token">
                                <button
                                    @click="confirm"
                                    class="w-full bg-[#2A3992] text-white font-semibold py-3 px-4 rounded-sm transition-all duration-300 hover:scale-105 shadow-lg shadow-blue-200"
                                >
                                    <i class="fi fi-rr-search mr-2"></i>
                                    Consulter
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4 sm:p-6 bg-white rounded-2xl border border-gray-100 space-y-6">

                <!-- Section des statistiques -->
                <div class="rounded-md p-4 sm:p-6 space-y-6">
                    <h3 class="font-semibold pb-6 border-b text-lg sm:text-xl border-gray-100">
                        Basé sur l'avis des utilisateurs
                    </h3>

                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 place-items-center">

                        <!-- Note globale -->
                        <div class="w-full text-center py-4 rounded-md">
                            <div class="text-5xl sm:text-6xl font-bold text-[#2A3993]">
                                {{ book.evaluation ?? 0 }}<span class="text-sm">/5</span>
                            </div>

                            <div class="flex justify-center mt-2">
                    <span v-if="book.evaluation > 0" class="flex justify-center">
                        <span
                            v-for="star in 5"
                            :key="star"
                            :class="[
                                'transition-colors duration-300',
                                star <= book.evaluation ? 'text-yellow-400' : 'text-gray-200'
                            ]"
                        >
                            <svg class="w-6 h-6 sm:w-5 sm:h-5 fill-current" viewBox="0 0 20 20">
                                <path
                                    d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
                            </svg>
                        </span>
                    </span>
                            </div>
                            <p class="font-medium text-lg sm:text-xl mt-2">
                                Basées sur {{ book.totalAvis }} avis
                            </p>
                        </div>

                        <!-- Répartition des notes -->
                        <div class="w-full sm:col-span-1 lg:col-span-3 space-y-3">
                            <div class="flex items-center" v-for="n in [5,4,3,2,1]" :key="n">
                    <span class="text-sm text-gray-600 w-16 text-left">
                        {{ '★'.repeat(n) + '☆'.repeat(5 - n) }}
                    </span>
                                <div class="flex-1 h-2 bg-gray-200 rounded-full ml-2">
                                    <div class="h-2 bg-yellow-400 rounded-full"
                                         :style="'width:' + getPourcent(n) + '%'"></div>
                                </div>
                                <span class="text-sm text-gray-500 ml-2">{{ getPourcent(n) }}%</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Avis récents -->
                <div class="space-y-6 max-h-96 overflow-y-auto custom-scrollbar rounded p-4 sm:p-6">
                    <h3 class="font-bold pb-4 border-b text-lg sm:text-xl border-gray-100 mb-4">
                        Avis récents
                    </h3>

                    <div class="border-b border-gray-100 pb-6 last:border-0 last:pb-0"
                         v-for="evaluation in book.evaluations" :key="evaluation.id">
                        <div class="flex items-start gap-4">
                            <img
                                :src="asset(evaluation.user.profil_photo ? 'user/photos/' + evaluation.user.profil_photo : 'images/profileDefault.png')"
                                alt="Avatar"
                                class="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover"
                            />
                            <div class="flex-1 space-y-2">
                                <div class="flex justify-between items-center">
                                    <h4 class="font-semibold text-gray-800">
                                        {{ evaluation.user.name }}
                                    </h4>
                                    <span class="text-xs sm:text-sm text-gray-500">
                            {{ formatDate(evaluation.updated_at ?? evaluation.created_at) }}
                        </span>
                                </div>
                                <div class="flex">
                        <span
                            v-for="star in 5"
                            :key="star"
                            :class="[
                                'transition-colors duration-300',
                                star <= evaluation.note ? 'text-yellow-400' : 'text-gray-200'
                            ]"
                        >
                            <svg class="w-3 h-3 sm:w-5 sm:h-5 fill-current" viewBox="0 0 20 20">
                                <path
                                    d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
                            </svg>
                        </span>
                                </div>
                                <p class="text-gray-600 text-sm sm:text-base">
                                    {{ evaluation.commentaire ?? 'Pas de commentaire' }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-full lg:w-75 lg:mx-auto md:w-75 md:mx-auto text-center">
                    <button
                        @click="currentUser ? isOpen = true : onLog = true"
                        class="w-full bg-white text-blue-600 font-semibold py-2 sm:py-3 px-4 sm:px-6 rounded-lg border-2 border-blue-200 hover:bg-blue-50 hover:border-blue-300 transition-all duration-300 shadow-sm text-sm sm:text-base"
                    >
                        {{ evaluation?.note ? 'Modifier votre avis' : 'Évaluer ce livre' }}
                    </button>
                </div>

            </div>

            <button id="openLoginModal" style="opacity: 0;visibility: hidden"></button>
        </div>

        <!-- Modals et composants -->
        <transition name="fade">
            <library-rating v-show="modalRating" @close="modalRating = false"/>
        </transition>

        <note-form
            v-if="isOpen"
            @close="isOpen = false"
            @updateState="bookDetails"
            :bookId="book.id"
            :evaluation="evaluation"
        />
        <log-modal
            v-if="onLog"
            @close="onLog=false"/>
        <consultation-form
            v-if="showModal"
            @closeModal="showModal = false"
            :book-id="book.id"
        />

    </div>
</template>

<script setup>
import {ref, computed, watch, onMounted} from 'vue'
import NoteForm from "@/vue/note/NoteForm.vue"
import DetailTravaux from "@/vue/DetailBook/DetailTravaux.vue"
import ConsultationForm from "@/vue/consultation/ConsultationForm.vue"
import LibraryRating from "@/vue/libraryRating/LibraryRating.vue"
import {NotificationToast} from "@/utils/notification.js";
import {getBearerToken, route} from "../../helper.js";
import {CustomConfirm} from "@/admin/functions/customConfirm.js";
import BookCover from "@/vue/DetailBook/BookCover.vue";
import LogModal from "@/vue/Form/LogModal/LogModal.vue";
import {asset} from "../../helper.js";

// Props
const props = defineProps({
    bookId: {
        type: Number,
        default: null
    },
    csrf_token: {
        type: String,
    },
    consultationRoute: {
        type: String,
    },
    authUser: {
        type: [String, Number, null],
        default: null
    },
    shareLink: String
})

const currentUser = ref(!isNaN(parseInt(props?.authUser)) ? parseInt(props?.authUser) : null)

// État local
const isFavorite = ref(false)
const bookState = ref(false)
const isOpen = ref(false)
const onLog = ref(false)
const showModal = ref(false)
const modalRating = ref(false)
const isLoading = ref(false)
const alreadyRating = ref()
const evaluation = ref({})
const book = ref({})
const avis = ref({})
const showFullDescription = ref(false)
const showFullExtrait = ref(false)

const readRoute = computed(() => {
    return book.value.book_file ? `/lecture/${book.value.id}` : null
})

const getPourcent = (note) => {
    return avis.value[note]
}

// Fonctions existantes
const checkFavoriteStatus = async () => {
    if (!book.value.id || !currentUser.value) return
    try {
        const response = await axios.get(`/favorisState/${book.value.id}`)
        isFavorite.value = response.data
    } catch (error) {
        console.error('Erreur favoris:', error)
    }
}

const checkBookState = async () => {
    if (!props.bookId || !currentUser.value) return
    try {
        const response = await axios.get(`/BookState/${props.bookId}`)
        bookState.value = response.data
    } catch (error) {
        console.log(error)
        console.error('Erreur:', error.response.data.message)
    }
}

watch(() => book.value, checkFavoriteStatus, {immediate: true})

const subChar = (text, limite) => {
    return text.substring(0, limite) + '...'
}

const addFavoris = async () => {
    if (!book.value.id) return
    if (!currentUser.value) {
        document.getElementById('openLoginModal').click()
        return
    }
    try {
        const response = await axios.get(`/addFavoris/${book.value.id}`)
        if (response.data?.message) {
            NotificationToast(response.data?.type, response.data.message)
        }
        await checkFavoriteStatus()
    } catch (error) {
        console.error('Erreur ajout favoris:', error.response.data.message)
    }
}

const removeFavoris = async () => {
    if (!book.value.id) return
    try {
        const response = await axios.get(`/removeFavoris/${book.value.id}`)
        if (response.data?.message) {
            NotificationToast(response.data.type, response.data.message)
        }
        await checkFavoriteStatus()
    } catch (error) {
        NotificationToast('error', error.response.data.message)
    }
}


const copyLink = async () => {
    if (props.shareLink) {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: book.value.title,
                    url: window.location.href
                });
            } catch (error) {
                NotificationToast('error', 'Erreur lors du partage')
            }
        } else {
            navigator.clipboard.writeText(props.shareLink)
            NotificationToast('success', 'Lien copié')
        }
    }
}

// Emprunter un livre
const loanBook = async () => {
    if (!book.value.id) return
    if (!currentUser.value) {
        // onLog.value = true
        document.getElementById('openLoginModal').click()
        return
    }
    try {
        const response = await axios.post(`/loan/${book.value.id}`)
        NotificationToast(response.data?.type, response.data.message)
        checkBookState()
    } catch (error) {
        NotificationToast('error', error.response.data.message)
    }
}

// Réserver un livre
const reserveBook = async () => {
    if (!book.value.id) return
    if (!currentUser.value) {
        // onLog.value = true
        document.getElementById('openLoginModal').click()
        // window.location.href = route('login')
        return
    }
    try {
        const response = await axios.post(`/reservation/${book.value.id}`)
        NotificationToast(response.data?.type, response.data.message)
        checkBookState()
    } catch (error) {
        NotificationToast('error', error.response.data.message)
    }
}

// Nouvelle fonction pour ouvrir le lecteur de livre
const openBookReader = () => {
    console.log(readRoute.value)
    if (book.value.isNumerique && readRoute.value) {
        window.location.href = readRoute.value
    } else {
        NotificationToast('error', 'Ce livre n\'est pas disponible en version numérique')
    }
}

const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    })
}
const calculerPourcentageNotes = (evalu) => {
    const evaluations = evalu || [];
    const total = evaluations.length;

    // Initialisation des notes possibles 1 à 5
    const result = {5: 0, 4: 0, 3: 0, 2: 0, 1: 0};

    if (total === 0) return result; // Aucun avis

    evaluations.forEach(e => {
        if (result[e.note] !== undefined) {
            result[e.note]++;
        }
    });

    Object.keys(result).forEach(note => {
        result[note] = ((result[note] / total) * 100).toFixed(0);
    });

    return result;
}

const bookDetails = async () => {
    isLoading.value = true
    try {
        let response
        if (getBearerToken()){
          response =   await axios.get('/api/bookDetails-with-token/' + props.bookId, {
              headers: {
                  Authorization: props.authUser ? `Bearer ${getBearerToken()}` : ''
              },
          });
        } else {
            response =   await axios.get('/api/bookDetails/' + props.bookId);
        }
        if (response.data) {
            book.value = response.data.book
            console.log(response.data.book)
            evaluation.value = response.data.evaluation
            alreadyRating.value = response.data.already_rating
            avis.value = calculerPourcentageNotes(book.value.evaluations)
        }
    } catch (error) {
        NotificationToast('error', error.response?.data?.message || 'Erreur lors du chargement du livre')
    }
    isLoading.value = false
}

onMounted(() => {
    bookDetails()
    checkBookState()
})
const confirm = (event) => {
    if (currentUser.value) {
        event.preventDefault()
        let form = event.target.parentElement
        form.setAttribute('action', props.consultationRoute)
        CustomConfirm(form, "Voulez-vous vraiment continuer ? <br> Ce processus ne peut pas être annulé.", 'Confirmer', 'btn__confirm')
    } else {
        onLog.value = true
    }
}

const favoriteButtonText = computed(() => {
    return isFavorite.value ? 'Retirer' : 'Favoris'
})
</script>

<style scoped>

.custom-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 #f1f5f9;
}

.custom-scrollbar::-webkit-scrollbar {
    width: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}


.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}

/* Animations supplémentaires */
@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
}

.hover\:animate-pulse:hover {
    animation: pulse 2s infinite;
}

@media (max-width: 640px) {
    .container {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }
}

.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>
